// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"Ribbon__wrapper--ltXa9"};